import { FC } from 'react'

import { Text } from '@revolut-internal/ui-kit'

import { BreachCell } from 'modules/Monitoring/components/TableCells/BreachCell'
import { TimeMetric } from 'modules/Monitoring/types'
import { formatDuration } from 'modules/Monitoring/utils/formatTimeAndDuration'

type DurationCellProps = {
  metric: TimeMetric | null
}

export const DurationCell: FC<DurationCellProps> = ({ metric }) => {
  if (!metric) {
    return <Text color="grey-tone-20">-</Text>
  }

  const slaBreachValue = metric.slaBreachValue
    ? formatDuration(metric.slaBreachValue)
    : undefined

  return (
    <BreachCell slaBreach={metric.slaBreach} slaBreachValue={slaBreachValue}>
      {formatDuration(metric.value)}
    </BreachCell>
  )
}
